export default function getEmailDomain({ email }) {
	const emailParts = email.toLowerCase().split("@")
	if (emailParts.length === 2) return emailParts[1].split(".")[0]
}
